import styled from "styled-components";

import { QUERIES, SPACING } from "../../../utils/constants";
import { Pill } from "../styles";

const PHONE_WIDTH_PX = 650;
const PHONE_QUERY = `(max-width: ${PHONE_WIDTH_PX / 16}rem)`;
const TIME_COLUMN_PX = 100;

export const ActivityRows = styled.ol`
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const ActivityRow = styled.li`
  border-bottom: 1px solid var(--color-border);

  &:last-child {
    border-bottom: 0;
  }
`;

export const ActivityDetails = styled.details`
  padding: ${SPACING.md}px 0;

  &[open] svg {
    transform: rotate(90deg);
  }
`;

export const ActivitySummary = styled.summary`
  display: flex;
  align-items: flex-start;
  gap: ${SPACING.md}px;
  cursor: pointer;
  list-style: none;

  &::-webkit-details-marker {
    display: none;
  }

  &:focus-visible {
    outline: 2px solid var(--color-primary);
    outline-offset: 2px;
  }

  svg {
    flex-shrink: 0;
    color: var(--color-text-secondary);
    transition: transform 0.15s ease-out;
  }

  @media (prefers-reduced-motion: reduce) {
    svg {
      transition: none;
    }
  }
`;

export const ActivityTime = styled.time`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.xxs}px;
  min-width: ${TIME_COLUMN_PX}px;
  font-size: var(--text-sm);
  color: var(--color-text-secondary);

  strong {
    font-size: var(--text-base);
    font-weight: 500;
    color: var(--color-text-default);
  }

  @media ${PHONE_QUERY} {
    width: 80px;
    min-width: 0;
    flex-shrink: 0;
  }
`;

export const ActivityMeta = styled.span`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: ${SPACING.xxs}px;
  min-width: 0;
  font-size: var(--text-sm);
  color: var(--color-text-secondary);
  overflow-wrap: anywhere;

  strong {
    font-size: var(--text-base);
    font-weight: 600;
    color: var(--color-text-default);
  }
`;

export const TargetPill = styled(Pill)`
  margin-left: auto;

  @media ${PHONE_QUERY} {
    display: none;
  }
`;

export const ActivityDetailBody = styled.div`
  padding: ${SPACING.sm}px 0 0 calc(${TIME_COLUMN_PX}px + ${SPACING.md}px);

  @media ${PHONE_QUERY} {
    padding: ${SPACING.sm}px 0 0;
  }
`;

export const DetailList = styled.dl`
  display: grid;
  grid-template-columns: minmax(90px, 160px) minmax(0, 1fr);
  gap: ${SPACING.xs}px ${SPACING.md}px;
  margin: 0;
  padding-top: ${SPACING.sm}px;
  border-top: 1px solid var(--color-border);
  font-size: var(--text-sm);

  dt {
    color: var(--color-text-secondary);
  }

  dd {
    margin: 0;
    color: var(--color-text-default);
    overflow-wrap: anywhere;
  }

  @media ${QUERIES.tabletAndDown} {
    grid-template-columns: 90px minmax(0, 1fr);
  }
`;

export const DetailGroupHeading = styled.dt`
  grid-column: 1 / -1;
  margin-top: ${SPACING.xs}px;
  font-weight: 600;
`;

export const Pager = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.sm}px;
  padding-top: ${SPACING.sm}px;
  border-top: 1px solid var(--color-border);

  @media ${QUERIES.tabletAndUp} {
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
  }
`;

export const PagerGrow = styled.div`
  flex: 1;
  min-width: 0;
`;

export const PageSizeControl = styled.div`
  display: flex;
  align-items: center;
  gap: ${SPACING.sm}px;
  font-size: var(--text-sm);
  color: var(--color-text-secondary);
  white-space: nowrap;
`;
